import { css } from "@emotion/react";

export const pageSectionCss = css`
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
`;

export const searchInputCss = css`
  width: 600px;
`;
